import { loadMoreInTable, initTableSelectionOnLoad } from 'owa-mail-list-actions';
import { getSelectedTableView, } from 'owa-mail-list-store';
import { lazyPrefetchFirstN } from 'owa-mail-prefetch';
import { getCanTableLoadMore } from 'owa-mail-table-loading-actions';
import { action } from 'satcheljs/lib/legacy';
var FIRST_N_ROW_PREFETCH_COUNT = 10;
/**
 * Try load more upon the initial load rows completed
 * @param tableView the table to load more
 */
var tryLoadMoreUponInitialLoadCompleted = action('tryLoadMoreUponInitialLoadCompleted')(function tryLoadMoreUponInitialLoadCompleted(tableView) {
    // Try to load more if necessary
    if (getCanTableLoadMore(tableView)) {
        setTimeout(function () {
            // Loading of more rows should be done asynchronously
            // We must check getCanTableLoadMore again after setTimeout
            if (getCanTableLoadMore(tableView)) {
                loadMoreInTable(tableView);
            }
        }, 100);
    }
});
/**
 * Callback for table load complete
 * @param tableView the table view
 * @param isSuccessResponseClass indicates if the response is success
 * @param isTablePrefetched indicates if the table is prefetched
 */
export default action('onInitialTableLoadSucceed')(function onInitialTableLoadComplete(tableView, isSuccessResponseClass, responseCode, isTablePrefetched, tableHasCachedItems) {
    // Set loading state to complete
    tableView.isLoading = false;
    tableView.isInitialLoadComplete = true;
    if (isTablePrefetched) {
        return;
    }
    // If the response class is success then prefetch and perform auto selection
    if (isSuccessResponseClass) {
        tableView.loadErrorStatus = 0 /* None */;
        var hasSelection = tableView.selectedRowKeys.size > 0;
        // do auto selection and prefetch first N rows for Folder and Group tables
        if (tableView.tableQuery.type == 0 /* Folder */ ||
            tableView.tableQuery.type == 2 /* Group */) {
            // Init table selection if we did not show cached results before.
            // If we had shown cached results, then initial selection would already have been done
            if (!hasSelection && tableView == getSelectedTableView()) {
                initTableSelectionOnLoad(tableView);
            }
            lazyPrefetchFirstN.importAndExecute(tableView, FIRST_N_ROW_PREFETCH_COUNT);
        }
        // Backfill more rows in the table
        tryLoadMoreUponInitialLoadCompleted(tableView);
    }
    else {
        switch (responseCode) {
            case 'ErrorAccessDenied':
                tableView.loadErrorStatus = 1 /* AccessDenied */;
                break;
            default:
                tableView.loadErrorStatus = 2 /* Other */;
        }
    }
});
//# sourceMappingURL=onInitialTableLoadComplete.js.map